import {
  MotifIcon,
} from "@/libs/@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import "../../Configuration/Attributes/Attributes.css";
import { CreateCategoryAllInputs } from "./createCategoryAllInputs";
import { useCase } from "@/features/case/use-case";
import { useTranslation } from "react-i18next";
import PageTitle from "@/components/Form/PageTitle/PageTitle";
import { ActiveTabsOrder } from "@/menuData";

export default function CreateCategory() {
  const { t } = useTranslation();
  const caseData = useCase();
  return (
    <div className="attribute-setup-container pad-h-60 pad-v-60">
          <div className="attributes-back-button">
            <Breadcrumb
              items={[
                {
                  text: caseData.caseName,
                  icon: <MotifIcon src={IconoirArrowLeft} />,
                  url: `/case/${caseData.caseId}?activeTab=${ActiveTabsOrder.CONFIGURATION}`,
                },
                {
                  text: t("pages.configuration.category.createCategory"),
                  icon: <MotifIcon src={IconoirArrowLeft} />,
                  url: `/case/${caseData.caseId}?activeTab=${ActiveTabsOrder.CONFIGURATION}`,
                  disabled: true,
                },
              ]}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          <PageTitle
            title={t("pages.configuration.category.categoryCreateTitle")}
            description={t("pages.configuration.category.categoryCreateDescription")}/>
        <CreateCategoryAllInputs />
    </div>
  );
}
